import { render, staticRenderFns } from "./AiWorkInfo.vue?vue&type=template&id=19961baf&scoped=true"
import script from "./AiWorkInfo.vue?vue&type=script&lang=js"
export * from "./AiWorkInfo.vue?vue&type=script&lang=js"
import style0 from "./AiWorkInfo.vue?vue&type=style&index=0&id=19961baf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19961baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19961baf')) {
      api.createRecord('19961baf', component.options)
    } else {
      api.reload('19961baf', component.options)
    }
    module.hot.accept("./AiWorkInfo.vue?vue&type=template&id=19961baf&scoped=true", function () {
      api.rerender('19961baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AiWorkInfo/AiWorkInfo.vue"
export default component.exports